import type { ComponentProps } from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"
import './popover.scss'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

/** Der Pfeil zum Auslöser; die Farbe setzt der Inhalt (`fill`/`stroke`), wie beim Panel selbst. */
const PopoverArrow = PopoverPrimitive.Arrow

/**
 * Hülle für ein Panel am Auslöser: Portal, Position, Escape, Klick-außen, Fokus.
 * Bringt bewusst keine eigene Optik mit — der Inhalt setzt seine Klasse selbst
 * (Regel „Inhalt + Hülle", siehe CLAUDE.md). Einzige Ausnahme: kein Fokus-Ring
 * am Panel selbst, das Radix beim Öffnen fokussiert, wenn nichts darin fokussierbar ist.
 *
 * @example
 * <Popover open={open} onOpenChange={setOpen}>
 *   <PopoverTrigger asChild>
 *     <button className="my-menu__trigger">…</button>
 *   </PopoverTrigger>
 *   <PopoverContent className="my-menu__panel" align="start">
 *     …
 *   </PopoverContent>
 * </Popover>
 */
function PopoverContent({
  className,
  sideOffset = 4,
  ...props
}: ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        sideOffset={sideOffset}
        className={`popover-content ${className || ''}`}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

export { Popover, PopoverTrigger, PopoverAnchor, PopoverArrow, PopoverContent }
